export default function updateQueryState(path: string) {
  if (path.length > 0) {
    globalThis?.history.replaceState(null, document.title, path);
  } else {
    const { pathname, hash } = globalThis?.location || {};
    const pathWithHash = globalThis?.location
      ? `${pathname}${hash}`
      : undefined;

    globalThis?.history.replaceState(null, document.title, pathWithHash);
  }
}
